import type { IntlCache } from 'react-intl'
import { createIntl } from 'react-intl'

import { DefaultElements, ResourceAliases } from '../placeholders/index.js'
import type { I18nConfig, I18nObject } from '../types.js'

export const createI18n: (
  config: I18nConfig,
  cache?: IntlCache,
) => I18nObject = ({ catalogLocale, ...config }, cache) => {
  const intl: I18nObject = createIntl(
    {
      ...config,
      defaultRichTextElements: {
        ...DefaultElements,
        ...config.defaultRichTextElements,
      },
    },
    cache,
  )

  const aliases = ResourceAliases(intl)
  const originalFormatMessage = intl.formatMessage
  intl.formatMessage = (descriptor, values, opts) => {
    return originalFormatMessage(descriptor, { ...aliases, ...values }, opts)
  }
  intl.catalogLocale = catalogLocale ?? config.locale

  return intl
}
